import React, {memo, useEffect} from 'react';
import {getPopulatedArr, isBoolTrue} from "../../common/fusion-ui/utils/ReactUtils";
import {Flexbox, Section, SkeletonBox} from "../../common/fusion-ui";
import useScreenSize from "../../common/fusion-ui/hook/useScreenSize";
import {useTheme} from "../../common/ProjectThemeProvider";

/**
 * TableLoadingSkeleton is a memoized functional component designed for displaying a loading skeleton for a table structure.
 * @param {string} className - Additional class names for styling.
 * @param {string} shadowVariant - Shadow variant for the skeleton elements, default is "sm".
 * @param {Object} style - Inline styles to be applied to the skeleton component.
 * @param {boolean} borderless - Determines if the skeleton should have borders.
 * @param {string} variant - Background variant for the skeleton elements, default is "tbl-skltn".
 * @param {number} rowCount - Number of rows to be displayed, default is 9.
 */
const TableLoadingSkeleton = memo(({
                                       className = "",
                                       shadowVariant = "sm",
                                       style = {},
                                       borderless = false,
                                       variant = 'tbl-skltn',
                                       rowCount = 9,
                                   }) => {
    const TAG = "TableLoadingSkeleton";
    const {isScreenUpSm} = useScreenSize();
    const theme = useTheme();

    useEffect(() => {

    }, []);

    return (<>
        <Section
            className={`w-100 mb-2 px-2 pt-3 height70 pb-2 border-0-5 ${className}`}
            borderless={borderless}
            shadowVariant={isBoolTrue(borderless) ? shadowVariant : 'none'}
            roundedVariant={3}
            style={{...style}}
            borderColor={theme.text10}
        >
            {/*header*/}
            <Flexbox justifyAt={'between jc-start-sm'} className={'px-1'}>
                {/*controls*/}
                <Flexbox>
                    <SkeletonBox className={'px-4 py-2 m-1'} bg={variant}/>
                    <SkeletonBox className={'px-5 py-2 m-1'} bg={variant}/>
                    {!isScreenUpSm && <SkeletonBox className={'px-5 py-2 m-1'} bg={variant}/>}
                    {!isScreenUpSm && <SkeletonBox className={'px-5 py-2 m-1'} bg={variant}/>}
                </Flexbox>
            </Flexbox>

            {/*table*/}
            <div className={'m-0 p-0 w-100 mt-2'}>
                {/*header*/}
                <Flexbox justifyAt={'between'}>
                    <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-3 my-1'} bg={variant}/></div>
                    <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-3 my-1'} bg={variant}/></div>
                    {!isScreenUpSm && <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-3 my-1'} bg={variant}/></div>}
                    {!isScreenUpSm && <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-3 my-1'} bg={variant}/></div>}
                    {!isScreenUpSm && <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-3 my-1'} bg={variant}/></div>}
                </Flexbox>

                {/*rows*/}
                <div className={'m-0 p-0 w-100'}>
                    {getPopulatedArr(0, isScreenUpSm ? parseInt(rowCount * 1.5) : rowCount).map((item, index) => {
                        return renderRow(item, index)
                    })}
                    {/*{renderRow()}*/}
                    {/*{renderRow()}*/}
                    {/*{renderRow()}*/}
                    {/*{renderRow()}*/}
                    {/*{renderRow()}*/}
                    {/*{renderRow()}*/}
                    {/*{renderRow()}*/}
                </div>


                {/*footer*/}
                <Flexbox justifyAt={'center'}>
                    <div className={'px-2 w-3'}><SkeletonBox className={'w-100 p-2 my-1'} bg={variant}/></div>
                    <div className={'px-2 w-5'}><SkeletonBox className={'w-100 p-2 my-1'} bg={variant}/></div>
                    {!isScreenUpSm && <div className={'px-2 w-3'}><SkeletonBox className={'w-100 p-2 my-1'} bg={variant}/></div>}
                    {!isScreenUpSm && <div className={'px-2 w-25'}><SkeletonBox className={'w-100 p-2 my-1'} bg={variant}/></div>}
                    {!isScreenUpSm && <div className={'px-2 w-10'}><SkeletonBox className={'w-100 p-2 my-1'} bg={variant}/></div>}
                </Flexbox>
            </div>
        </Section>
    </>)

    function renderRow(item, index) {
        return <div className={'m-0 p-0 w-100'} key={item + 'mm' + index}>
            <Flexbox justifyAt={'between'}>
                <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-2 pb-3 my-1'} bg={variant}/></div>
                <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-2 pb-3 my-1'} bg={variant}/></div>
                <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-2 pb-3 my-1'} bg={variant}/></div>
                <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-2 pb-3 my-1'} bg={variant}/></div>
                <div className={'px-2 w-20'}><SkeletonBox className={'w-100 p-2 py-2 pb-3 my-1'} bg={variant}/></div>
            </Flexbox>
        </div>
    }
});
export default TableLoadingSkeleton;
